import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';
import Badge from 'atomic/badge';
import OfferLabelInterface from 'interfaces/offer-label.interface';

import './offer-label.scss';

interface OfferLabelProps {
    label?: OfferLabelInterface | null;
    className?: string;
    // `small` dla kafelków, w których metka leży na wąskiej miniaturze i przy domyślnym
    // stopniu pisma zostawałby na treść wielokropek; `ranking` tam, gdzie sąsiaduje
    // z innymi badge'ami i musi trzymać ich stopień pisma.
    size?: 'default' | 'small' | 'ranking';
}

const OfferLabel: FC<OfferLabelProps> = ({ label, className, size = 'default' }): ReactElement | null => {
    if (!label) {
        return null;
    }

    return (
        <Badge
            className={classNames('offer-label', `offer-label--${size}`, className)}
            weight="600"
            backgroundColor={label.backgroundColor}
            textColor={label.textColor}
        >
            <span>{label.name}</span>
        </Badge>
    );
};

export default OfferLabel;
